var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUkFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3289_987)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3289_987",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -291,
    y: 0,
    width: 1182,
    height: 600
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-290.164 0V600H890.164V0H-290.164Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3289_987)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-290.164 0V600H890.164V0H-290.164Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-290.164 0L890.164 600ZM890.164 0L-290.164 600Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-290.164 0L890.164 600M890.164 0L-290.164 600",
    stroke: "white",
    strokeWidth: 120
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3289_987",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -291,
    y: 0,
    width: 1182,
    height: 600
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300 300H890.164V600L300 300ZM300 300V600H-290.164L300 300ZM300 300H-290.164V0L300 300ZM300 300V0H890.164L300 300Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3289_987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-290.164 0L890.164 600ZM890.164 0L-290.164 600Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-290.164 0L890.164 600M890.164 0L-290.164 600",
    stroke: "black",
    strokeWidth: 80
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300 0V600ZM-290.164 300H890.164Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300 0V600M-290.164 300H890.164",
    stroke: "white",
    strokeWidth: 200
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M300 0V600ZM-290.164 300H890.164Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M300 0V600M-290.164 300H890.164",
    stroke: "black",
    strokeWidth: 120
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3289_987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    rx: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/ukFlag.fdf32d017c2d14b84b41f390e9abbe28.svg";
export { ForwardRef as ReactComponent };